export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/about": [6],
		"/accident-by-driver": [7],
		"/accident-list": [8],
		"/acord-apps": [9],
		"/acord125": [10],
		"/additional-interest": [11],
		"/agency-admin": [12],
		"/agency-list": [13],
		"/applicant-info": [14],
		"/auto-liability": [15],
		"/auto-physical-damage": [16],
		"/brokerage-coverage": [17],
		"/brokerage-info": [18],
		"/captive-analysis": [19],
		"/cargo": [20],
		"/commodities-excess": [21],
		"/commodities-hauled": [22],
		"/commodities-info": [23],
		"/company-contacts": [24],
		"/company-strengths": [25],
		"/contract-owners": [26],
		"/customer": [27],
		"/cyber-security": [28],
		"/dashboard": [29],
		"/deductible-analysis": [30],
		"/driver-info": [31],
		"/drivers-list": [32],
		"/emails": [33],
		"/epic-integrations": [34],
		"/filings": [35],
		"/financials": [36],
		"/fmcsa-accident-analysis": [38],
		"/fmcsa": [37],
		"/freight-forwarding": [39],
		"/fuel-tax": [40],
		"/general-liability": [41],
		"/hired-auto": [42],
		"/import-everything": [43],
		"/import-fuel-tax": [44],
		"/import-loss-runs": [45],
		"/import-mvrs": [46],
		"/insurance-companies": [47],
		"/insurance-history": [48],
		"/landfill-supplemental": [49],
		"/lead-finder": [50],
		"/lienholder": [51],
		"/loss-stratification": [52],
		"/maintenance-info": [53],
		"/market-manager-captives": [54],
		"/market-manager-ic": [55],
		"/market-manager-mga": [56],
		"/mgas": [57],
		"/mileage-rev-pu": [58],
		"/monthly-reporting-exposures": [59],
		"/mvrs": [60],
		"/named-insured": [61],
		"/ncci-modifiers": [62],
		"/non-truckers": [63],
		"/operations-exposure": [64],
		"/operations-info": [65],
		"/payroll-history": [66],
		"/physical-locations": [67],
		"/producer-info": [68],
		"/profile": [69],
		"/public/pay-invoice/[token]": [70,[3]],
		"/radius-operations": [71],
		"/report-builder": [72],
		"/safety-info": [73],
		"/safety-materials": [74],
		"/(agency-modules)/sample-module": [5,[2]],
		"/submission-builder": [75],
		"/system-admin": [76],
		"/tank-wash": [77],
		"/telematics": [78],
		"/trailer-interchange": [79],
		"/umbrella-excess": [80],
		"/vehicles-list": [81],
		"/waste-materials": [82],
		"/workers-comp": [83]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';